import { makeStyles } from '@material-ui/core/styles';

export const useDocumentRequirementsStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#fff',
    boxShadow: '0 0 10px rgba(0,0,0,.1)',
    padding: '0 25px'
  },
  tabStyles: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: '1px solid #e6e5e5'
  },
  list: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    marginTop: '17px',
    '& ul': {
      marginLeft: '24px'
    }
  },
  listItem: {
    flex: 1,
    marginLeft: '24px'
  },
  docListingWrapper: {
    color: 'var(--neutrals-black)',
    display: 'inline-table',
    marginRight: '30px',
    '& .doc_listing': {
      color: 'var(--neutrals-black)',
    },
    '& ul': {
      marginTop: '0px',
      marginLeft: '24px'
    }
  }
}));
